import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            独家策划与重磅企划，精选平台最值得关注的内容专题
          </p>
        </div>

        <div className="flex flex-col gap-6">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col md:flex-row bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-full md:w-[360px] lg:w-[420px] aspect-[16/9] md:aspect-auto flex-shrink-0 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full mb-4 w-fit">
                  {item.badge}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <a
                  href="#cards"
                  className="whitespace-nowrap inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 mt-4 cursor-pointer"
                >
                  查看详情
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}